// extracted by mini-css-extract-plugin
module.exports = {"navigationsOptions":"styles_navigationsOptions__7REO5","item":"styles_item__3VyRS"};